<template>
  <fragment>
  <div class="resources-landing1 resources-landing   bright std-cont">
    <div class="container">
        <h1 class="h1-title">お問合わせ</h1>
        <button class="btn-green-bold"><i aria-hidden="true" class="fa fa-arrow-left"></i><a href="#/faq" >お問合わせの前にFAQをご覧ください。直ちに解決する場合がございます</a></button>
        <form action="" class="form">
            <div class="form-group">
                <label for="name">お名前 (必須)</label>
                <input type="text" id="name" class="form-control">
            </div>
            <div class="form-group">
                <label for="email">メールアドレス (必須) ※誤りがあると返信が出来ませんのでご注意ください。</label>
                <input type="email" id="email" class="form-control">
            </div>
            <div class="form-group">
                <label for="title">題名</label>
                <input type="text" id="title" class="form-control">
            </div>
            <div class="form-group">
                <label for="content">メッセージ本文</label>
                <textarea id="content" class="form-control textarea"></textarea>
            </div>
            <div class="note">
                <p class="text-bold">エラーに関するお問合わせは、必ず下記の情報をご連絡ください</p>
                <p class="text-light">・ご利用の端末 （PC、Mac、iPhone、Android 等）
                    <br>・OSの種類（Windows10 64bit、MacOS10.13.3、iOS10.3.2、Android10.0 等）
                    <br>・ブラウザの種類とバージョン（Chrome65、FireFox59.0.1、Safari12.0.2 等）
                    <br>※Microsoft Edge、及び InternetExplorerには対応しておりません。
                    <br>・エラーメッセージの表示がある場合はその内容。
                    <br>・（重要）可能でしたら、画面を写真かスクリーンショットでお送りください。</p>
            </div>
            <div class="files">
                <input type="file" id="file1" name="file1">
                <input type="file" id="file2" name="file2">
            </div>
            <div  class="contact" id="btn-submit"><span class="btn-square">送信する</span> </div>
        </form>
    </div>
   </div>
  </fragment>
</template>

<style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: sans-serif;
        }
        .btn-square {
          display: inline-block;
          padding: 0.5em 1em;
          text-decoration: none;
          background: #668ad8;/*ボタン色*/
          color: #FFF;
          border-bottom: solid 4px #627295;
          border-radius: 3px;
        }
      .btn-square:active {
  /*ボタンを押したとき*/
         -webkit-transform: translateY(4px);
          transform: translateY(4px);/*下に動く*/
         border-bottom: none;/*線を消す*/
      }
        
        .container {
            width: 90%;
            max-width: 1100px;
            margin: auto;
        }
        
        .container .h1-title {
            font-size: 29px;
            margin: 40px 0;
        }
        
        .container .btn-green-bold {
            display: block;
            font-size: 16px;
            line-height: 1.5;
            color: #FFFFFF;
            background-color: #A49144;
            border: 1px solid #A49144;
            border-radius: 8px;
            padding: 12px 30px 12px 25px;
            margin: 0 auto 70px;
            cursor: pointer;
            transition: all .3s;
        }
        .container .btn-green-bold a{
            color:#ffffff;
        }
        
        .container .btn-green-bold:hover {
            background-color: #FFFFFF;
        }
        
        .container .btn-green-bold:hover a{
            color: #A49144;
        }
        
        .container .btn-green-bold i {
            margin-right: 14px;
        }
        
        .container .form {
            width: 100%;
            max-width: 612px;
            margin: auto;
        }
        
        .container .form .form-group {
            margin-bottom: 50px;
        }
        
        .container .form .form-group label {
            display: block;
            font-size: 16px;
            margin-bottom: 5px;
        }
        
        .container .form .form-group .form-control {
            display: inline-block;
            width: 100%;
            max-width: 377px;
            height: 52px;
            font-size: 16px;
            padding: 10px 15px;
            background: #0d0e0f;
            outline-color: #ffc637;
            background-color: #ddd;
            color: #333;
            border: 0;
            border-radius: 3px;
        }
        
        .container .form .form-group .form-control.textarea {
            height: 324px;
        }
        
        .container .form .note {}
        
        .container .form .note .text-bold {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 30px;
        }
        
        .container .form .note .text-light {
            font-size: 14px;
            line-height: 2;
            color: #111;
            margin-bottom: 10px;
        }
        
        .container .form .files {
            margin-bottom: 30px;
        }
        
        .container .form .files input {
            display: block;
            max-width: 100%;
            background-color: #ddd;
            font-size: 16px;
            color: #333;
            padding: 10px 15px;
            outline-color: #ffc637;
            border-radius: 3px;
            cursor: pointer;
        }
        
        .container .form #btn-submit {
            cursor: pointer;
        }
        
        @media (max-width: 576px) {
            .container .h1-title {
                font-size: 24px;
                margin: 30px 0;
            }
            .container .btn-green-bold {
                display: flex;
                align-items: center;
                padding: 10px 20px 10px 15px;
                margin-bottom: 50px;
            }
            .container .btn-green-bold i {
                margin-right: 10px;
            }
            .container .form .form-group label {
                font-size: 14px;
            }
            .container .form .form-group {
                margin-bottom: 30px;
            }
            .container .form .form-group .form-control {
                height: 45px;
            }
            .container .form .form-group .form-control.textarea {
                height: 232px;
            }
        }
    </style>

 
   <script>
       export default {
        mounted: function () {
            console.log("sfsdsdfdsfsdfsdf")
            this.$nextTick(function () {
           this.highLowIntro()
           })
       },
         methods: {
           highLowIntro(){
            const toBase64 = file => new Promise((resolve, reject) => {
                 const reader = new FileReader();
                 reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                 reader.onerror = error => reject(error);
             });

          let btnSubmit = document.getElementById("btn-submit");
          btnSubmit.addEventListener("click",async (e) => {
            e.preventDefault();
            let name = document.getElementById("name").value;
            let email = document.getElementById("email").value;
            let title = document.getElementById("title").value;
            let content = document.getElementById("content").value;
            let file1 ;
            let file2;
            if(document.getElementById("file1").value){
               file1 = await toBase64( document.querySelector('#file1').files[0]);
            }
            if(document.getElementById("file2").value){
               file2 = await toBase64( document.querySelector('#file2').files[0]);
            }
            
            const link = "https://send-mail.rion-lab.com:9046/contact";
            var Request = new XMLHttpRequest();
            Request.open("POST", link, true);
            Request.setRequestHeader("Content-Type", "application/json");
            Request.setRequestHeader("Expect", "");
            Request.onreadystatechange = function () {
            if (Request.readyState == 4 && Request.status == 200 ) {
                alert("お問い合わせ完了しました。")
                location.replace("https://bi-winning.org/");
             }
           }
          let body={
               email: "admin@bi-winning.org",
               fromName: "Bi-Winning",
               subject: "Bi-Winning お問合わせ",
               bfile1:file1,
               bfile2:file2,
               content:`<section style="text-align: left;margin: auto;max-width: 550px;">
                    <div>
                         <p>
                             お名前 (必須):${name}
                         </p>
                         <p>
                            メールアドレス:${email}
                         </p>
                         <p>
                             題名:${title}
                         </p>

                          <p>
                            メッセージ本文:${content}
                         </p>
                         <p>
                         スクリーンショット
                         </p>
                      
                         <img src="#FILE1#" />
                         <img src="#FILE2#" />

                    </div>
             </section>`

          }
          Request.send(JSON.stringify(body));
        })
             }
         }
       }
    
   </script>